import { FC } from 'react';
import cls from './progress-bar-segment.module.scss';

interface ProgressBarSegmentProps {
  progress: number;
  isActive?: boolean;
}

export const ProgressBarSegment: FC<ProgressBarSegmentProps> = ({
  progress,
  isActive = false,
}) => {
  const fillPercent = Math.max(0, Math.min(1, progress)) * 100;

  return (
    <div className={`${cls.segment} ${isActive ? cls.segmentActive : ''}`}>
      <div className={cls.segmentTrack} />
      <div className={cls.segmentFill} style={{ width: `${fillPercent}%` }} />
      {isActive ? (
        <div
          className={cls.segmentIndeterminate}
          style={{ left: `${fillPercent}%` }}
        >
          <span className={cls.segmentIndeterminateBar} />
        </div>
      ) : null}
    </div>
  );
};
